<template>
  <div class="VehicleParking">
    <div class="chart" ref="chart" />
  </div>
</template>

<script>
import echarts from "echarts";
import api from "../api";

export default {
  name: "VehicleParking",
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.queryInfo();
  },
  methods: {
    async queryInfo() {
      const { success, returnObj } = await this.$fetch(api.platform.queryVehicleTimeLong);
      if (success) {
        this.initCharts(returnObj);
      }
    },
    initCharts(obj) {
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      const listData = [];

      for (let key in obj) {
        listData.push({
          name: key,
          value: obj[key],
        });
      }
      const total = listData.reduce((pre, cur) => {
        return pre + cur.value;
      }, 0);

      console.log(total);
      // [
      // { value: obj.oneHour, name: "1小时内" },
      // { value: obj.twelveHour, name: "1-12小时" },
      // { value: obj.twentyFourHour, name: "12-24小时" },
      // { value: obj.upTwentyFourHour, name: "24小时以上" },
      // ];
      const option = {
        color: ["#93BEFF", "#FAC858", "#623FF3", "#49C384"],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        series: [
          {
            name: "车辆停靠统计",
            type: "pie",
            radius: ["30%", "60%"],
            avoidLabelOverlap: true,
            label: {
              normal: {
                formatter: function (params, ticket, callback) {
                  var percent = 0; //考生占比
                  if (total == 0) {
                    percent = 0;
                    return "{name|" + params.name + "}\n{blue|" + percent + "%}";
                  } else {
                    percent = ((params.value / total) * 100).toFixed(1);
                    return "{name|" + params.name + "}\n{blue|" + percent + "%}";
                  }
                },
                rich: {
                  name: {
                    color: "#EEB9F7",
                    fontSize: 14,
                    // padding: [21, 0],
                    align: "center",
                  },
                  blue: {
                    color: "#FFFFFF",
                    fontSize: 14,
                    align: "center",
                  },
                },
              },
            },
            labelLine: {
              normal: {
                length: 10,
                length2: 15,
                lineStyle: {
                  color: "#F2A5FF",
                },
              },
            },
            data: listData,
          },
        ],
      };

      this.chart = echarts.init(this.$refs.chart);
      this.chart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.VehicleParking {
  height: 100%;
  width: 100%;

  .chart {
    height: 100%;
    width: 100%;
  }
}
</style>
